// AthleteReportCategory.ts

import { isEmpty, isNotEmpty } from "@/pipes";
import { ScoutingReportScore } from "@best-athletes/ba-types";

export function ratingToScore(rating: ScoutingReportScore): number {
    switch(rating) {
        case ScoutingReportScore.Score1: return 20;
        case ScoutingReportScore.Score2: return 40;
        case ScoutingReportScore.Score3: return 60;
        case ScoutingReportScore.Score4: return 80;
        case ScoutingReportScore.Score4Plus: return 90;
        default: return rating * 20;
    }
}
export class AthleteReportCategory {
	name: string;
	score?: number;
	rating?: ScoutingReportScore;
	notes?: string;

    constructor(name: string, rating?: ScoutingReportScore, notes?: string, score?: number) {
        this.name = name;
        this.rating = rating;
        this.notes = notes;
        this.score = score;

        // convert from old rating (1-4+) to new score (1-100)
        if( isEmpty(this.score) && isNotEmpty(this.rating) ) this.score = ratingToScore(this.rating);
    }
}

export class AthleteReportCategoryHeading extends AthleteReportCategory {
	categories: Array<AthleteReportCategory> = [];
	expanded: boolean = false;
}

